<script setup lang="ts">
/**
 * 源站 .push-banner：fixed 顶栏，粉渐变 + logo + 文案 + Suscribirse + 关闭。
 * CSS 从现网 data-v-6750a244 抄录；max-width 768 走移动端字号。
 */
import { ref } from 'vue';
import { t } from '@/shared/i18n/messages';
import { oroMxAssetPaths } from '@/shared/theme/oro-mx-home-data';

const STORAGE_KEY = 'oro-mx-push-banner-dismissed';
const visible = ref(sessionStorage.getItem(STORAGE_KEY) !== '1');

function dismiss() {
  visible.value = false;
  sessionStorage.setItem(STORAGE_KEY, '1');
}

async function subscribe() {
  if (typeof Notification !== 'undefined' && Notification.permission === 'default') {
    try {
      await Notification.requestPermission();
    } catch {
      /* 浏览器拦截时仍关闭条，避免卡死 */
    }
  }
  dismiss();
}
</script>

<template>
  <div v-if="visible" class="push-banner">
    <div class="push-banner__content">
      <img class="push-banner__logo" :src="oroMxAssetPaths.pushLogo" alt="Logo" />
      <span class="push-banner__text">
        {{ t('oro.push.text') }}
      </span>
      <button class="push-banner__btn" type="button" @click="subscribe">{{ t('oro.push.subscribe') }}</button>
      <button class="push-banner__close" type="button" :aria-label="t('oro.common.close')" @click="dismiss">
        <svg viewBox="0 0 24 24" width="16" height="16" fill="currentColor" aria-hidden="true">
          <path d="M19 6.41L17.59 5 12 10.59 6.41 5 5 6.41 10.59 12 5 17.59 6.41 19 12 13.41 17.59 19 19 17.59 13.41 12z" />
        </svg>
      </button>
    </div>
  </div>
</template>

<style scoped>
.push-banner {
  position: fixed;
  top: 0;
  right: 0;
  left: 0;
  /* 高于 3600 弹层挡板（奖池/刮刮乐等），低于 4000 支付 / 4200 登录 */
  z-index: 3800;
  background: linear-gradient(90deg, #fff5f5, #ffe8e8);
  box-shadow: rgb(0 0 0 / 15%) 0 0.05333rem 0.21333rem;
}

.push-banner__content {
  display: flex;
  gap: 0.64rem;
  align-items: center;
  max-width: 100%;
  padding: 0.64rem 0.85333rem;
}

.push-banner__logo {
  flex-shrink: 0;
  width: 1.70667rem;
  height: 1.70667rem;
  object-fit: contain;
}

.push-banner__text {
  flex: 1 1 0%;
  overflow-wrap: break-word;
  color: #333;
  font-size: 0.85333rem;
  line-height: 1.5;
  word-break: break-word;
  white-space: normal;
}

.push-banner__btn {
  display: flex;
  flex-shrink: 0;
  align-items: center;
  justify-content: center;
  height: 1.70667rem;
  padding: 0 0.85333rem;
  color: #fff;
  font-size: 0.74667rem;
  font-weight: 500;
  background: #e74c3c;
  border: none;
  border-radius: 0.85333rem;
  cursor: pointer;
}

.push-banner__close {
  display: flex;
  flex-shrink: 0;
  align-items: center;
  justify-content: center;
  width: 1.28rem;
  height: 1.28rem;
  padding: 0;
  color: #999;
  background: transparent;
  border: 0;
  border-radius: 50%;
  cursor: pointer;
}

@media (max-width: 768px) {
  .push-banner__content {
    gap: 0.42667rem;
    padding: 0.53333rem 0.64rem;
  }

  .push-banner__logo {
    width: 1.49333rem;
    height: 1.49333rem;
  }

  .push-banner__text {
    font-size: 0.74667rem;
  }

  .push-banner__btn {
    height: 1.49333rem;
    padding: 0 0.64rem;
    font-size: 0.64rem;
  }

  .push-banner__close {
    width: 1.06667rem;
    height: 1.06667rem;
  }
}
</style>
